/**
 * @fileoverview GET handler for the "/engagement/get_changelogs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementGetChangelogs } from "./constants";
import type { EngagementGetChangelogsResult } from "./types";

export const getEngagementGetChangelogs = reactQueryFetcherAdapter(
  engagementGetChangelogs,
  (signal: AbortSignal, id: string, type: string): Promise<EngagementGetChangelogsResult> => {
    return fetch("/engagement/get_changelogs", "GET", { id, type }, { signal });
  }
);
